import { styled } from '@mui/material/styles'
import { Typography, Container as MuiContainer } from '@mui/material'
import { Button as SuiButton } from 'settle-ui/components/Button/Button'

export const Container = styled(MuiContainer)(({ theme }) => ({
  marginTop: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}))

export const Title = styled((props) => (
  <Typography align="center" variant="h3" color="primary" {...props} />
))<React.PropsWithChildren>(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
}))

export const Button = styled(SuiButton)(({ theme }) => ({
  width: '270px',
  alignSelf: 'center',
  margin: theme.spacing(2, 0),
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}))
